import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Input, InputGroup, InputGroupAddon, InputGroupText, Table } from 'reactstrap';
import { Card, CardHeader, CardBody, CardText, CardFooter } from 'reactstrap';
import logo from './Imagenes/Iconos/ESPOL-extracurriculares.svg';
import url from "./variables/url.js";
import "react-pro-sidebar/dist/css/styles.css";
/*import pdfPrueba from './Content/plantilla.pdf';*/
import './PDF.css';
import AllPagesPDFViewer from './All-page';
import Certificado from './Certificado';
import SinglePagePDFViewer from './Single-page';

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;

const ColoredLine = ({ color }) => (
    <hr
        style={{
            color: color,
            backgroundColor: color,
            height: 2
        }}
    />
);

export class Autenticado extends Component {
    static displayName = Autenticado.name;

    constructor(props) {
        super(props);
        this.state = {
            iduser: 0,
            Autenticado: [],
            actividades: [],
            codigo: '',
            insignias: [],
            loading1: true,
            loading2: true,
            buscar: '',
            pdfResult: 0,
            pdfBase64: ''
        };

        this.handleSearch = this.handleSearch.bind(this);
        this.searchById = this.searchById.bind(this);
    }

    componentDidMount() {
        var cer = this.props.match.params["codigo"];        
        if (cer !== '') {            
            this.setState({ buscar: cer });
            this.populatePdf();
        }
        /*console.log(this.state.buscar);*/        
    }

    handleSearch = async function (event) {
        await this.setState({ buscar: event.target.value });
        /*console.log(this.state.buscar);*/
    }

    searchById() {
        /*this.populateActividad(this.state.buscar, 'A');*/
        if (this.state.buscar !== '') {
            fetch(localBack + '/api/Certificado/GetByCodigo/' + this.state.buscar, {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => response.json())
                .then(data => {                    
                    if (data.strEstado === "S") {
                        let certificadoRow = data.objDatos;
                        let codigo = certificadoRow.rutapdf.split(',');                        
                        this.getPdf(codigo[1]);
                    } else {
                        //console.log('Documento No existe.');
                    }
                });
            this.setState({ pdfResult: 1 });
        } else {
            this.setState({ pdfResult: -1 });
        }        
    }

    populatePdf() {
        /*this.populateActividad(this.state.buscar, 'A');*/
        if (this.state.buscar !== '') {
            fetch(localBack + '/api/Certificado/GetByCodigo/' + this.props.match.params["codigo"], {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => response.json())
                .then(data => {
                    if (data.strEstado === "S") {
                        let certificadoRow = data.objDatos;
                        let codigo = certificadoRow.rutapdf.split(',');
                        this.getPdf(codigo[1]);
                    } else {
                        //console.log('Documento No existe.');
                    }
                });
            this.setState({ pdfResult: 1 });
        } else {
            this.setState({ pdfResult: -1 });
        }
    }

    getPdf(id) {
        fetch(localBack+'/api/FileUpload/DescargarEvidencia/'+id, {
            method: 'GET',
        })
            .then(response => {
                this.setState({ status: response.status });
                return response.json();
            })
            .then(data => {
                if (data !== '') {
                    this.setState({
                        pdfBase64: "data:application/pdf;base64," + data + "", pdfResult: 1
                    });                    
                } else {
                    this.setState({ pdfResult: -1 });
                }                
            });
    }

    populateInsigniaResult(id) {
        fetch(localBack + '/api/ResultadoInsignia/GetbyEstado/' + id, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log('insignia: ', data);*/
                this.setState({ insignias: data.objDatos, loading1: false });
            });
        /*console.log('Resultado ', this.state.insigniaResult);*/

    }

    populateActividad(id, estado) {
        fetch(localBack + '/api/RegistroActividad/GetActByEstado/' + id + '/' + estado, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log('criterio: ', data);*/
                this.setState({ actividades: data.objDatos, loading2: false });
            });
        /*console.log('Criterio ', this.state.criterio);*/
    }

  render () {
    return (
        <div className="wrapper"> 
            
                <Row style={{ minHeight: '75vh' }}>
                    <Col>
                        <Card>
                            <CardHeader>Autenticaci&oacute;n</CardHeader>
                            <CardBody>
                                
                                <CardText>Ingrese el c&oacute;digo del certificado para verificar autenticidad.</CardText>
                                <CardText>
                                    <Row>                                        
                                            <InputGroup className="col-md-12">                                                
                                                <Input placeholder="201505398083604052022" onChange={this.handleSearch} value={this.state.buscar} />
                                                <InputGroupAddon addonType="append">
                                                    <InputGroupText className='icon-pointer' onClick={() => this.searchById()}>
                                                        Consultar
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                            </InputGroup>                                        
                                    </Row>
                                </CardText>                                
                                {this.state.pdfResult > 0 ? 
                                    <Card body className="all-page-container" style={{ alignContent: 'center', height: '100%', maxHeight: '500px', overflow: 'auto' }}>
                                        <AllPagesPDFViewer pdf={this.state.pdfBase64} />
                                    </Card>
                                    : this.state.pdfResult < 0
                                        ?
                                        <Card body className="text-center py-3">
                                            <CardText>No se encontr&oacute; el certificado.</CardText>
                                            <CardText>Por favor, verifique que le c&oacute;digo se haya escrito correctamente.</CardText>
                                        </Card>
                                        :
                                        <></>
                                    }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
               
        </div>
    );
  }
}
